import Image from './image.web';
// import { initAvailHost } from './helper';
export default Image;
// initAvailHost().catch(() => {});
